import { Button, Drawer, FormControl, Grid, IconButton, InputLabel, MenuItem, Popover, Select, useTheme } from "@mui/material";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


import { DateRange } from 'react-date-range';

import CloseIcon from '@mui/icons-material/Close';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useEffect, useRef, useState } from "react";
import { formatDateToTimestamp, getDatestring } from "../../utils/date";

// import DownloadOptions from "./DownloadOptions";


interface TableOptionsBarProps {
    // downloadData?: DownloadData;
    searchValue: string;
    setSearchValue?: (value: string) => void;

    rangeControlProps?: RangeControlProps;

    selectControlProps?: SelectControl;
    firstSelectControlProps?: SelectControl;
    loading: boolean;
    tableRows: any[];
    customItemOptionBarMiddle?: any;
    customItemOptionBar?: any;
    customStartItemOptionBar?: any;
    setDrawerFiltersOpen?: (open: boolean | undefined ) => void;
    drawerFiltersOpen?: boolean | undefined;
    hiddenFilterOptions?: boolean | undefined;
    tableOptionsBar: {
        useDrawer: boolean;
    },
}

export interface RangeControlProps {
    minDate?: Date | null,
    maxDate?: Date | null,
    setMinRangeDateSelected?: (newDate: Date | null) => void;
    setMaxRangeDateSelected?: (newDate: Date | null) => void;
    startDate?: Date | null;
    endDate?: Date | null;
    setStartDate?: (newDate: Date | null) => void;
    setEndDate?: (newDate: Date | null) => void;
}

interface SelectControlItems {
    label: string;
    value: string;
}

export interface SelectControl {
    label: string;
    onChange?: (value: string) => void;
    options?: SelectControlItems[];
    value?: SelectControlItems['value'];
    autocalculateFieldName?: string;
    onChangeSelectControl?: (key: string, value: string) => void,
}


const TableOptionsBar = ({
    // downloadData, 
    searchValue, 
    setSearchValue, 
    rangeControlProps,
    selectControlProps,
    firstSelectControlProps,
    loading,
    tableRows,
    customItemOptionBar: CustomItemOptionBar,
    customItemOptionBarMiddle: CustomItemOptionBarMiddle,
    customStartItemOptionBar: CustomStartItemOptionBar,
    drawerFiltersOpen,
    setDrawerFiltersOpen,
    tableOptionsBar,
    hiddenFilterOptions,
}: TableOptionsBarProps) => {
    const theme = useTheme();
    const divRef = useRef()
    const [openDatePicker, setopenDatePicker] = useState(false)
    const [dtRangeFocus, setDtRangeFocus] = useState<number[]>([])
    const [selectOptions, setSelectOptions] = useState<SelectControl['options']  | string[]>(selectControlProps?.options || ["Todos"])
    const [firstSelectOptions, setFirstSelectOptions] = useState<SelectControl['options']  | string[]>(firstSelectControlProps?.options || ["Todos"])
    const [selectOptionValue, setSelectOptionValue] = useState<string>(String(selectControlProps?.value || "Todos"))
    const [firstSelectOptionValue, setFirstSelectOptionValue] = useState<string>(String(firstSelectControlProps?.value || "Todos"))

    const [state, setState] = useState([
        {
          startDate: rangeControlProps?.startDate ? new Date(rangeControlProps?.startDate) : null,
          endDate: rangeControlProps?.endDate ? new Date(rangeControlProps?.endDate) : null,
          key: 'selection'
        }
    ]);

    const handlerSetMinRangeDateSelected = (date: Date) => {
        if (rangeControlProps?.setMinRangeDateSelected) {
            rangeControlProps?.setMinRangeDateSelected(date)
        };
    };

    const handlerSetMaxRangeDateSelected = (date: Date) => {
        if (rangeControlProps?.setMaxRangeDateSelected && date) {
            rangeControlProps?.setMaxRangeDateSelected(date);
        }
    };

    const handlerFirstAutocalculateOptions = () => {
        if (!firstSelectControlProps?.autocalculateFieldName || !tableRows) {
            return;
        }
        const fieldName = firstSelectControlProps.autocalculateFieldName;
        let selectOptions = tableRows.reduce((acc, obj) => {
            if (!acc.includes(obj[fieldName])) {
              acc.push(obj[fieldName]);
            }
            return acc;
        }, [] as string[]);
        if (!selectOptions.includes("Todos")) {
            selectOptions = ["Todos", ...selectOptions];
        }
        setFirstSelectOptions(selectOptions)
    }

    const handlerAutocalculateOptions = () => {
        if (!selectControlProps?.autocalculateFieldName || !tableRows) {
            return;
        }
        const fieldName = selectControlProps.autocalculateFieldName;
        let selectOptions = tableRows.reduce((acc, obj) => {
            if (!acc.includes(obj[fieldName])) {
              acc.push(obj[fieldName]);
            }
            return acc;
        }, [] as string[]);
        if (!selectOptions.includes("Todos")) {
            selectOptions = ["Todos", ...selectOptions];
        }
        setSelectOptions(selectOptions)
    }

    useEffect(() => {
        handlerAutocalculateOptions();
        handlerFirstAutocalculateOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableRows])

    useEffect(() => {
        if (state && state[0]?.startDate && state[0]?.endDate 
            && dtRangeFocus.length === 2 && !dtRangeFocus[0] && !dtRangeFocus[1]
        ) {
            handlerSetMinRangeDateSelected(state[0].startDate.setHours(0) as any);
            handlerSetMaxRangeDateSelected((state[0].endDate as Date).setHours(23) as any);
            setopenDatePicker(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, state)

    const handleChange = (event: any) => {
        if (!setSearchValue) {
            return
        }
        setSearchValue(event.target.value);
    };
    
    useEffect(() => {
        if (
            hiddenFilterOptions ||
            (!CustomStartItemOptionBar && 
            !rangeControlProps &&
            !selectControlProps &&
            !firstSelectControlProps &&
            !CustomItemOptionBarMiddle &&
            !setSearchValue &&
            !CustomItemOptionBar)
            
        ) {
            return;
        }
        if (drawerFiltersOpen === undefined && setDrawerFiltersOpen) {
            setDrawerFiltersOpen(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        CustomStartItemOptionBar, 
        rangeControlProps, 
        selectControlProps, 
        firstSelectControlProps,
        CustomItemOptionBarMiddle, 
        setSearchValue, 
        CustomItemOptionBar
    ])

    if (
        hiddenFilterOptions ||
        (!CustomStartItemOptionBar && 
        !rangeControlProps &&
        !selectControlProps &&
        !firstSelectControlProps &&
        !CustomItemOptionBarMiddle &&
        !setSearchValue &&
        !CustomItemOptionBar)
    ) {
        return <></>
    }
    

    if (tableOptionsBar.useDrawer && drawerFiltersOpen !== undefined && setDrawerFiltersOpen) {
        return <Drawer
            anchor="right"
            open={drawerFiltersOpen}
            onClose={() => setDrawerFiltersOpen(false)}
            BackdropProps={{style:{backgroundColor: "unset", opacity: 0}}}
        >
            <div style={{ width: 250, padding: 20, marginTop: "4rem" }}>
            <IconButton 
                onClick={() => setDrawerFiltersOpen(false)} 
                style={{ position: 'absolute', top: "4.5rem", right: 10 }} 
                aria-label="close"
            >
                <CloseIcon />
            </IconButton>
            <h3>Filtrar</h3>
            {setSearchValue &&
                <Grid item>
                    <input
                        placeholder="Buscar..." 
                        style={{
                            width: "100%",
                            marginTop: ".2rem",
                            height: "2rem", 
                            borderRadius: ".25rem",
                            border: `1px solid ${theme.s10palette.S10Greygrey50}`,
                        }}
                        value={searchValue || ""}
                        onChange={handleChange} 
                    />  
                </Grid>
            }
            {CustomStartItemOptionBar && 
                <Grid item style={{paddingTop: "1.5rem"}}>
                    <CustomStartItemOptionBar />
                </Grid>
            }
            {rangeControlProps && 
                <Grid item ref={divRef as any} style={{paddingTop: "1.5rem"}}>
                    <Button 
                        startIcon={<EditCalendarIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        variant="contained"
                        disableElevation
                        style={{
                            border: theme.s10palette.S10Greygrey50,
                            backgroundColor: "white",
                            color: theme.s10palette.S10Greygrey600,
                            fontSize: !state[0].startDate || !state[0].endDate ? ".8rem" : ".8rem",
                            lineHeight: "1rem",
                            padding: "0",
                            // width: "100%",
                        }}
                        onClick={() => setopenDatePicker(true)}
                    >
                        {   !state[0].startDate || !state[0].endDate
                            ? loading
                                ? "cargando..."
                                : "Rango de fecha"
                            : `del ${formatDateToTimestamp(state[0].startDate)} al ${formatDateToTimestamp(state[0].endDate)}`
                        }
                    </Button>
                    {!loading && <Popover 
                        anchorEl={divRef.current}
                        open={openDatePicker}
                        style={{marginTop: "3rem"}}
                    >
                        <Grid textAlign="right" style={{backgroundColor: "none"}}>
                            <IconButton onClick={() => setopenDatePicker(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <DateRange
                            minDate={rangeControlProps?.minDate ? rangeControlProps?.minDate : undefined}
                            maxDate={rangeControlProps?.maxDate ? rangeControlProps?.maxDate : undefined}
                            editableDateInputs={false}
                            onRangeFocusChange={(item) => {
                                setDtRangeFocus(item);
                            }}
                            onChange={item => {
                                setState([item.selection as any]);
                            }}
                            
                            moveRangeOnFirstSelection={false}
                            ranges={(state || []) as any}
                        />
                    </Popover>}
                </Grid>
            }
            {firstSelectControlProps?.label && firstSelectOptions?.length && 
                <Grid item style={{paddingTop: "1.5rem"}}> 
                    <FormControl style={{width: "100%"}}>
                        <InputLabel id="select-option-label">{firstSelectControlProps.label}</InputLabel>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            label={firstSelectControlProps.label}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setFirstSelectOptionValue(String(value))
                                if (firstSelectControlProps?.onChange) {
                                    firstSelectControlProps.onChange(value)
                                } else if (firstSelectControlProps.onChangeSelectControl) {
                                    firstSelectControlProps.onChangeSelectControl(
                                        value === "Todos" ? "" : firstSelectControlProps.autocalculateFieldName as any,
                                        value === "Todos" ? "" : value,
                                    )
                                }
                            }}
                            value={firstSelectOptionValue}
                            style={{height: "2rem", border: "none", backgroundColor: "white"}}
                        >
                            {firstSelectOptions?.map((item, i) => (
                                <MenuItem 
                                    key={i} 
                                    value={typeof item === "string" 
                                        ? item 
                                        : item?.value 
                                    }
                                >
                                    {typeof item === "string" 
                                        ? item
                                            ? item
                                            : "Todos" 
                                        : item?.label
                                    }
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            }
            {selectControlProps?.label && selectOptions?.length && 
                <Grid item style={{paddingTop: "1.5rem"}}> 
                    <FormControl style={{width: "100%"}}>
                        <InputLabel id="select-option-label">{selectControlProps.label}</InputLabel>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            label={selectControlProps.label}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setSelectOptionValue(String(value))
                                if (selectControlProps?.onChange) {
                                    selectControlProps.onChange(value)
                                } else if (selectControlProps.onChangeSelectControl) {
                                    selectControlProps.onChangeSelectControl(
                                        value === "Todos" ? "" : selectControlProps.autocalculateFieldName as any,
                                        value === "Todos" ? "" : value,
                                    )
                                }
                            }}
                            value={selectOptionValue}
                            style={{height: "2rem", border: "none", backgroundColor: "white"}}
                        >
                            {selectOptions?.map((item, i) => (
                                <MenuItem 
                                    key={i} 
                                    value={typeof item === "string" 
                                        ? item 
                                        : item?.value 
                                    }
                                >
                                    {typeof item === "string" 
                                        ? item
                                            ? item
                                            : "Todos" 
                                        : item?.label
                                    }
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            }
            {CustomItemOptionBarMiddle && <Grid item style={{paddingTop: "1.5rem"}}>
                <CustomItemOptionBarMiddle />
            </Grid>}

            {CustomItemOptionBar && 
                <Grid item style={{paddingTop: "1.5rem"}}>
                    <CustomItemOptionBar />
                </Grid>
            }
            
            </div>
        </Drawer>   
    }

    return (
        <>
        
        <Grid 
            container
            direction="column"
            style={{
                backgroundColor: "#EFF4F6", 
                width: "100%",
                height: "4rem",
                borderRadius: "0.5rem",
                padding: ".75rem",
                marginTop: "2rem",
                overflowX: 'auto',
                overflowY: 'hidden'
            }}
            justifyContent="space-between"
        >
            <Grid 
                container 
                item 
                justifyContent="start" 
                style={{ width: 'max-content',  }}
            >

                {CustomStartItemOptionBar && <Grid item style={{padding: "0 .5rem"}}>
                    <CustomStartItemOptionBar />
                </Grid>}
                {rangeControlProps && <Grid item ref={divRef as any} style={{padding: "0 .5rem"}}>
                    <Button 
                        startIcon={<EditCalendarIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        variant="contained"
                        disableElevation
                        style={{
                            minHeight: "2.5rem",
                            border: theme.s10palette.S10Greygrey50,
                            backgroundColor: "white",
                            color: theme.s10palette.S10Greygrey600,
                            // marginRight: "1.5rem",
                            fontSize: !state[0].startDate || !state[0].endDate ? "1rem" : ".8rem"
                        }}
                        onClick={() => setopenDatePicker(true)}
                    >
                        {   !state[0].startDate || !state[0].endDate
                            ? loading
                                ? "cargando..."
                                : "Rango de fecha"
                            : `del ${getDatestring(state[0].startDate, "/")} \nal ${getDatestring(state[0].endDate, "/")}`
                        }
                    </Button>
                    {!loading && <Popover 
                        anchorEl={divRef.current}
                        open={openDatePicker}
                        style={{marginTop: "3rem"}}
                    >
                        <Grid textAlign="right" style={{backgroundColor: "none"}}>
                            <IconButton onClick={() => setopenDatePicker(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <DateRange
                            minDate={rangeControlProps?.minDate ? rangeControlProps?.minDate : undefined}
                            maxDate={rangeControlProps?.maxDate ? rangeControlProps?.maxDate : undefined}
                            editableDateInputs={false}
                            onRangeFocusChange={(item) => {
                                setDtRangeFocus(item);
                            }}
                            onChange={item => {
                                setState([item.selection as any]);
                            }}
                            
                            moveRangeOnFirstSelection={false}
                            ranges={(state || []) as any}
                        />
                    </Popover>}
                </Grid>}
                {/* <DownloadOptions downloadData={downloadData} /> */}

                {firstSelectControlProps?.label && firstSelectOptions?.length && <Grid item style={{padding: "0 .5rem"}}> 
                    <FormControl style={{minWidth: "10rem"}}>
                        <InputLabel id="select-option-label">{firstSelectControlProps.label}</InputLabel>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            label={firstSelectControlProps.label}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setFirstSelectOptionValue(String(value))
                                if (firstSelectControlProps?.onChange) {
                                    firstSelectControlProps.onChange(value)
                                } else if (firstSelectControlProps.onChangeSelectControl) {
                                    firstSelectControlProps.onChangeSelectControl(
                                        value === "Todos" ? "" : firstSelectControlProps.autocalculateFieldName as any,
                                        value === "Todos" ? "" : value,
                                    )
                                }
                            }}
                            value={firstSelectOptionValue}
                            style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                        >
                            {firstSelectOptions?.map((item, i) => (
                                <MenuItem 
                                    key={i} 
                                    value={typeof item === "string" 
                                        ? item 
                                        : item?.value 
                                    }
                                >
                                    {typeof item === "string" 
                                        ? item
                                            ? item
                                            : "Todos" 
                                        : item?.label
                                    }
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>}
                {selectControlProps?.label && selectOptions?.length && <Grid item style={{padding: "0 .5rem"}}> 
                    <FormControl style={{minWidth: "10rem"}}>
                        <InputLabel id="select-option-label">{selectControlProps.label}</InputLabel>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            label={selectControlProps.label}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setSelectOptionValue(String(value))
                                if (selectControlProps?.onChange) {
                                    selectControlProps.onChange(value)
                                } else if (selectControlProps.onChangeSelectControl) {
                                    selectControlProps.onChangeSelectControl(
                                        value === "Todos" ? "" : selectControlProps.autocalculateFieldName as any,
                                        value === "Todos" ? "" : value,
                                    )
                                }
                            }}
                            value={selectOptionValue}
                            style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                        >
                            {selectOptions?.map((item, i) => (
                                <MenuItem 
                                    key={i} 
                                    value={typeof item === "string" 
                                        ? item 
                                        : item?.value 
                                    }
                                >
                                    {typeof item === "string" 
                                        ? item
                                            ? item
                                            : "Todos" 
                                        : item?.label
                                    }
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>}
                {CustomItemOptionBarMiddle && <Grid item style={{padding: "0 .5rem"}}>
                    <CustomItemOptionBarMiddle />
                </Grid>}
            </Grid>



            {(setSearchValue || CustomItemOptionBar) && <Grid item >
                <Grid container justifyContent="flex-end" alignItems="center">
                    {setSearchValue && <>
                        {/* <Grid item>
                            <Typography variant="subtitle1" color={theme.s10palette.S10Greygrey600} fontSize="1rem">
                                Buscar:
                            </Typography> 
                        </Grid>
                        <Grid item> */}
                        <input
                            placeholder="Buscar..." 
                            style={{
                                // width: "12.5rem", 
                                height: "2.5rem", 
                                marginLeft: ".5rem",
                                borderRadius: ".25rem",
                                border: `1px solid ${theme.s10palette.S10Greygrey50}`,
                            }}
                            onChange={handleChange} 
                        />  
                        {/* </Grid> */}
                    </>}
                    {CustomItemOptionBar && <CustomItemOptionBar />}
                </Grid>
            </Grid>}

        </Grid>
        </>
    )
}

export default TableOptionsBar;